<template>
  <div>
    <Head :title="title" />

    <div class="flex items-center justify-between mb-6">
      <h1 class="text-2xl font-bold">{{ title }}</h1>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold bg-gray-100">
            <th class="pb-4 pt-6 px-6">Plan Name</th>
            <th class="pb-4 pt-6 px-6">Start</th>
            <th class="pb-4 pt-6 px-6">End</th>
            <th class="pb-4 pt-6 px-6">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="plan in plans"
            :key="plan.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="border-t px-6 py-4">{{ plan.name }}</td>
            <td class="border-t px-6 py-4">{{ plan.start_date }}</td>
            <td class="border-t px-6 py-4">{{ plan.end_date }}</td>
            <td class="border-t px-6 py-4">{{ plan.amount }}</td>
          </tr>
          <tr v-if="!plans.length">
            <td class="px-6 py-4 border-t text-gray-500" colspan="4">
              No plans found for this customer.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  components: {
   SearchInput,
    Head,
    Icon,
    Link,
      Pagination,
  },
  layout: Layout,
  props: {
    title: String,
    customer: Object,
    plans: Array
  }
}
</script>
